import { withRouter } from 'react-router'

import FeaturedLocations from './FeaturedLocations'

export default withRouter(FeaturedLocations)
